export default __webpack_public_path__ + "static/Declaration_EGIB_MY-ecc8711e7b4c08798faf4b6d57995ea8.pdf";